import React, { ReactNode } from 'react';
import Select from 'react-select';
import Arrow from './Arrow';

export interface SelectBoxOption {
  label: React.ReactNode;
  value: string | number;
}

export interface SelectBoxProps {
  className?: string;
  disabled?: boolean;
  formatOptionLabel?: (label, value) => ReactNode;
  isClearable?: boolean;
  isSearchable?: boolean;
  label?: string;
  noOptionsMessage?: string;
  onInputChange?: (option: string) => void;
  isOptionDisabled?: (option: SelectBoxOption) => boolean;
  onOptionChange?: (option: SelectBoxOption) => void;
  options: SelectBoxOption[];
  placeholder?: string;
  value?: string;
  variation?: 'primary' | 'secondary' | 'rounded';
  size?: 'small';
}

const DropdownIndicator = () => {
  return (
    <span className="icon shadow icon-regular">
      <Arrow />
    </span>
  );
};

const SelectBox: React.FC<SelectBoxProps> = ({
  className,
  disabled,
  formatOptionLabel,
  isClearable = false,
  isSearchable = false,
  noOptionsMessage,
  onInputChange = () => undefined,
  isOptionDisabled = () => false,
  onOptionChange,
  options,
  placeholder,
  value,
  variation = 'primary',
  size,
}) => {
  return (
    <Select
      isOptionDisabled={isOptionDisabled}
      className={`${className} ${variation}`}
      isClearable={isClearable}
      value={options.find(o => o.value === value)}
      menuPlacement="auto"
      isDisabled={disabled}
      formatOptionLabel={formatOptionLabel}
      onInputChange={v => v && !!onInputChange && onInputChange(v)}
      onChange={v => v && !!onOptionChange && onOptionChange(v)}
      isSearchable={isSearchable}
      components={{
        DropdownIndicator,
      }}
      options={options}
      placeholder={placeholder}
      noOptionsMessage={() => (noOptionsMessage ? noOptionsMessage : 'No results')}
      classNames={{
        container: () => `selectbox ${size ? size : ''}`,
        control: value => `selectbox-inner ${value.menuIsOpen ? 'focus' : ''}`,
        indicatorsContainer: () => 'icon',
        indicatorSeparator: () => 'display-none',
        input: () => 'selectbox-input',
        menu: () => 'selectbox-list',
        menuList: () => 'selectbox-list-inner',
        option: value => `selectbox-list-item ${value.isSelected ? 'selected' : ''}`,
        placeholder: () => 'selectbox-placeholder selectbox-input',
        singleValue: () => 'selectbox-input',
        valueContainer: () => 'selectbox-value',
      }}
    />
  );
};

export default SelectBox;
